import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"


export const Tutorial = () => {

  return (
    <div className='font-dashboard pt-8 pb-24 lg:px-4'>
      <div className='bg-black px-4 lg:px-10 py-10'>
        <div className='max-w-[765px] mx-auto'>
          <h1 className='text-3xl font-semibold text-primary text-center'>
            Tutorials
          </h1>

          <div className='w-full flex flex-col gap-4 mt-12 min-h-[70vh]'>

            <Accordion type="multiple">
              <AccordionItem value="item-1">
                <AccordionTrigger className="text-white">How to sell gift cards ?</AccordionTrigger>
                <AccordionContent className="text-white/90">
                  1. Launch the app.
                  2. Click on sell gift card
                  3. Select the gift card
                  4. Select the sub category
                  5. Enter the amount
                  6. You will see the value you get
                  7. Upload the images, you can select multiple images at once
                  8. You can enter the code or pin the the box that is named (additional notes)
                  9. Click on sell
                  10. Your order goes into pending status before it is processed and then completed
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger className="text-white">How to sell Cryptocurrency?</AccordionTrigger>
                <AccordionContent className="text-white/90">
                  Using the Gcbuying app, you can currently sell up to 5 different coins namely Bitcoin, Usdt, Ethereum, XRP, Dogecoin

                  1. Click on Crypto quick sell ( Sell crypto)

                  2. There are toggle buttons at the top of the screen which you can use to switch back and
                  forth from one coin to the other
                  3. For the sake of illustration, you can tap on bitcoin
                  4. You can send bitcoin to your uniquely generated bitcoin address solely for you either via
                  copying the wallet address or scanning the QR CODE
                  5. Once your transaction is confirmed on the blockchain (3 block confirmations), your naira
                  wallet is instantly credited
                  6. You can then proceed to withdraw your funds
                  7. You will received push notifications all the way through from when your coin is confirmed
                  to when your withdrawal request is completed
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger className="text-white">How to enter your payout details?</AccordionTrigger>
                <AccordionContent className="text-white/90">
                  How do you get paid might be a question you have. Follow the steps below

                  1. Click on profile which you can find at the bottom bar
                  2. Click on bank list
                  3. Click on add bank
                  4. You can either select any local nigerian banks, or bitcoin, usdt or mobile money
                  5. Complete filling in your information
                  6. Click on ADD
                  7. Click on withdrawal
                  8. Click on withdraw funds
                  9. Select from the list of payout options you already added
                  10. Enter the amount you wish to withdraw
                  11. Click on the withdraw button
                  12. Wait for the withdrawal to be processed instantly
                </AccordionContent>
              </AccordionItem>
            </Accordion>


          </div>
        </div>
      </div>
    </div>
  )
}
